module.exports = __webpack_public_path__ + "static/images/styles/images/landing/landing-award-large.d9d781c3.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/landing/landing-award-large.png
// module id = 3650
// module chunks = 11